import { auth } from '../firebase';

export async function apiFetch(path: string, options: RequestInit = {}) {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;

  const headers = new Headers(options.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  // The web deploys with the backend, so it always advertises the new
  // capabilities — legacy fallbacks (e.g. lazy BJJ-profile creation on the
  // belt endpoints) are reserved for older installed mobile builds.
  if (!headers.has('X-BlackBelts-Capabilities')) {
    headers.set('X-BlackBelts-Capabilities', 'explicit-bjj-profile');
  }

  // Default to JSON unless specified otherwise
  if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }
  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json');
  }

  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  const response = await fetch(cleanPath, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    // Optional: Handle session expiry or logout
    console.error('Unauthorized access');
  }

  return response;
}

const DEFAULT_ERROR_MESSAGE = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';

export async function parseApiError(response: Response, fallback?: string): Promise<string> {
  try {
    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      return fallback || DEFAULT_ERROR_MESSAGE;
    }
    const body = await response.json();
    return body.errors?.join(', ') || body.error || fallback || DEFAULT_ERROR_MESSAGE;
  } catch {
    return fallback || DEFAULT_ERROR_MESSAGE;
  }
}
